import React from 'react';
import { Bucket, pct } from '../../utils/matchAnalysis';

interface DistributionChartProps {
  title: React.ReactNode;
  buckets: Bucket[];
  caption?: string;
}

const DistributionChart: React.FC<DistributionChartProps> = ({ title, buckets, caption }) => {
  const max = Math.max(...buckets.map((b) => b.value), 0.0001);
  const top = buckets.findIndex((b) => b.value === max);

  return (
    <div className="dash-card">
      <div className="dash-card__head">
        <h3 className="dash-card__title">{title}</h3>
        {caption && <span className="dash-card__caption">{caption}</span>}
      </div>
      <div className={`dist-chart${buckets.length > 9 ? ' dist-chart--dense' : ''}`}>
        {buckets.map((b, i) => (
          <div key={b.label} className={`dist-chart__col${i === top ? ' dist-chart__col--top' : ''}`}>
            <span className="dist-chart__value">{pct(b.value)}</span>
            <span className="dist-chart__track">
              <span className="dist-chart__bar" style={{ height: `${(b.value / max) * 100}%` }} />
            </span>
            <span className="dist-chart__label">{b.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DistributionChart;
